import script from "./GestaoEpis.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoEpis.vue?vue&type=script&setup=true&lang=js"

import "./GestaoEpis.vue?vue&type=style&index=0&id=04656a3a&scoped=true&lang=css"
import "./GestaoEpis.vue?vue&type=style&index=1&id=04656a3a&lang=css"
import "./GestaoEpis.vue?vue&type=style&index=2&id=04656a3a&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04656a3a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QInput,QBtn,QDialog,QCard,QCardSection,QItem,QItemSection,QMarkupTable,QCheckbox,QPagination,QField});
